/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Err_Pick_DestInputs */

const vi_pdc_err_pick_dest = /** @type {(inputs: Pdc_Err_Pick_DestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vị trí đích`)
};

/**

* @param {Pdc_Err_Pick_DestInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_err_pick_dest = /** @type {((inputs?: Pdc_Err_Pick_DestInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Err_Pick_DestInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_err_pick_dest(inputs)
});